export default __webpack_public_path__ + "static/extraverdieping-mobile-4344bc2afd6dc694a1577965b2051113.svg";